import { useContext } from 'react';
import { M1ArticleModule, M1ArticleModuleProps } from 'ui/components/3-organisms/M1ArticleModule/M1ArticleModule';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

export const M1ArticleModuleFeature: React.FC<Umbraco.M1ArticleModule> = ({ content }) => {
	const { background } = content?.properties ?? {};
	const dictionary = useContext(DictionaryContext);

	const { properties } = content;

	if (!properties) {
		return null;
	}

	return <M1ArticleModule {...properties} backgroundColorKey={background} />;
};
